import firebase from '../../lib/firebase.prod';
import * as PROJECT_CODE from '../../constants/projectCode';

const firebaseRef = firebase.database();

export default async function getPurchaserById(salesAgentId, id) {
	console.log('getPurchaserById params', salesAgentId, id);
	var leadInfo;
	await firebaseRef
		.ref(
			'/kavtek_purchasers/' +
				PROJECT_CODE.projectCode +
				'/' +
				salesAgentId +
				'/' +
				id
		)
		.once('value', (snapshot) => {
			leadInfo = snapshot.val();
			console.log('getLead id', leadInfo);
		});

	console.log(
		'getPurchaserById id',
		'/kavtek_purchasers/' +
			PROJECT_CODE.projectCode +
			'/' +
			salesAgentId +
			'/' +
			id
	);
	return leadInfo;
}
